module.exports = __webpack_public_path__ + "static/media/something_went_wrong.15a3a772.png";